import { usePathname } from "next/navigation";
import { useMemo } from "react";

/**
 * Hook to determine if a route is active based on current pathname
 * @param url - The URL to check against
 * @returns boolean indicating if the route is active
 */
export function useActiveRoute(url: string): boolean {
  const pathname = usePathname();

  return useMemo(() => {
    if (!pathname) return false;
    if (url === "/" && pathname === "/") return true;
    if (url !== "/" && pathname.startsWith(url)) return true;
    return false;
  }, [pathname, url]);
}
